import classnames from 'classnames';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import Tag from '../../../../components/Tag';
import TagsContainer from '../../../../components/Tag/TagsContainer';
import './style.scss';
import { jsx as _jsx } from "react/jsx-runtime";

var StoryTags = function StoryTags(_ref) {
  var className = _ref.className,
      tagKeys = _ref.tagKeys,
      tags = _ref.tags,
      onMount = _ref.onMount,
      onUnmount = _ref.onUnmount;
  useEffect(function () {
    if (onMount && typeof onMount === 'function') {
      onMount(tagKeys);
    }

    if (onUnmount && typeof onUnmount === 'function') {
      return onUnmount;
    }
  }, []);
  var classes = classnames('ptr-StoryTags ptr-light', {}, className);
  return /*#__PURE__*/_jsx(TagsContainer, {
    className: classes,
    children: tags && tags.map(function (tag) {
      return /*#__PURE__*/_jsx(Tag, {
        children: tag.data.nameDisplay
      }, tag.key);
    })
  });
};

StoryTags.propTypes = {
  className: PropTypes.string,
  onMount: PropTypes.func,
  onUnmount: PropTypes.func,
  tags: PropTypes.array,
  tagKeys: PropTypes.array
};
export default StoryTags;